<script>
import Layout from '@layouts/default'
import ProductPanel from '@components/product-panel'
import VehicleSearch from '@components/vehicle-search'
import VehicleSearchSummary from '@components/vehicle-search-summary'
import { referralMethods, isTokenValid, customerMethods } from '@state/helpers'
import _ from 'lodash'

export default {
  page: {
    title: 'AutoCheck vehicle history reports | AutoCheck.com',
    meta: [
      {
        name: 'description',
        content:
          'Get the same vehicle history report that auto industry professionals rely upon to support their vehicle purchasing decisions.',
      },
    ],
    link: [
      {
        rel: 'canonical',
        href:
          'https://www.autocheck.com/vehiclehistory/vehicle-history-reports',
      },
    ],
  },
  components: { Layout, ProductPanel, VehicleSearch, VehicleSearchSummary },
  data() {
    return {
      products: [],
      tryingToGetProducts: false,
      errorMessage:
        'The item you attempted to purchase is not currently available. Please select an option below.',
      badProduct: _.get(this, '$store.state.customer.validCart'),
    }
  },
  created: function() {
    this.products = this.tryToGetProducts()
  },
  methods: {
    ...referralMethods,
    ...customerMethods,
    tryToGetProducts() {
      // If invalid token timeout
      if (!isTokenValid()) {
        this.$router.push({
          name: 'logoutAndShowSessionTimeout',
        })
        return
      }

      this.tryingToGetProducts = true
      return this.getProducts()
        .then((response) => {
          this.tryingToGetProducts = false
          this.products = response
          this.setBadCart(false)
        })
        .catch((error) => {
          this.tryingToGetProducts = false
          this.productError = error
        })
    },
    triggerItemViewGAEvent() {
      if (this.$gtag) {
        for (let product of this.products) {
          const item = {
            item_id: product.code,
            item_name: product.name,
            price: parseFloat(product.price),
            currency: 'USD',
            quantity: 1,
          }

          this.$gtag.event('view_item', {
            currency: 'USD',
            value: parseFloat(product.price),
            items: [item],
          })
        }
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <ul class="breadCrumbs">
          <BaseBreadcrumbs
            :routes="[
              {
                name: 'reports-list',
                title: 'AutoCheck vehicle history reports',
              },
            ]"
          />
        </ul>
      </div>

      <div v-if="badProduct" class="col-12">
        <b-alert variant="danger" show dismissible>
          {{ errorMessage }}
        </b-alert>
      </div>
      <div class="col-12 mt-1 mb-1">
        <VehicleSearchSummary />
      </div>
      <div class="col-12 mt-4 mb-4">
        <h1>AutoCheck<sup>&reg;</sup> vehicle history reports</h1>
        <p
          >Get the same vehicle history report that auto industry professionals
          rely upon to support their vehicle purchasing decisions.</p
        >
        <div class="row">
          <div v-if="!tryingToGetProducts" class="col-12">
            {{ triggerItemViewGAEvent() }}
            <ProductPanel
              v-for="(product, index) in products"
              :key="index"
              :product="product"
            />
          </div>
          <div class="container">
            <div class="row mb-4">
              <div class="col-sm-6 d-inline-block"
                ><a
                  href="https://www.keysavvy.com/partners/autocheck?aaId=exp&buyOrSell=buy"
                  target="_blank"
                >
                  <img
                    src="images/KeySavvy-AutoCheck-teamup-bnr.png"
                    alt="Buying or selling your vehicle private party?"
                /></a>
              </div>
              <div class="col-sm-6 d-inline-block"
                ><a
                  href="https://www.keysavvy.com/partners/autocheck/ev?aaId=exp"
                  target="_blank"
                >
                  <img
                    src="images/KeySavvy-EV-tax-credit-bnr.png"
                    alt="Apply the used EV tax credit when buying private party"
                /></a>
              </div>
            </div>
          </div>
          <div class="col-lg-8 col-12">
            <VehicleSearch />
          </div>
          <div class="col-lg-4 col-12">
            <div class="content"
              ><div style="margin: 30px;"
                ><BaseLink :to="{ name: 'sample-report' }"
                  ><img
                    width="150"
                    vspace="0"
                    hspace="0"
                    height="131"
                    border="0"
                    align="middle"
                    src="images/VHR-Sample.gif"
                    alt="AutoCheck Sample Report"
                /></BaseLink>
                <p
                  ><BaseLink :to="{ name: 'sample-report' }"
                    >See a Sample Report »</BaseLink
                  ></p
                >
                <p>&nbsp;</p>
              </div></div
            >
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
</style>
